export const PANEL_DETAIL_FIELDS = 'group,name,usr_id,allow_universe_only,process_retweet,lang_check,langs,auto_sentiment,anti_spam,custom_options,neutral,instagram_hashtags_active,account_id,universe_id';

export const PANEL_QUERY_FIELDS = 'account_id,universe_id,user_id';

/*
 * Maps nested structure from getPanelLimits into flat panel object.
 * getPanelLimits returns: { universe: {...}, account: {...}, limits: {...} }
 */
export function fieldsFromLimits(limits) {
  const { universe = {}, account = {}, limits: l = {} } = limits;
  return {
    name: universe.universe_name || '',
    status: universe.status || '',
    created_at: universe.created_at,
    warroom_account_name: account.account_name || '',
    posts_collected: l.posts_collected,
    month_posts_limit: l.month_posts_limit,
    total_posts_limit: l.total_posts_limit,
    total_month_listening_posts: l.total_month_listening_posts,
    total_month_proprietary_posts: l.total_month_proprietary_posts,
    total_month_competitors_proprietary_posts: l.total_month_competitors_proprietary_posts,
    month_posts: l.month_posts,
    total_group_posts: l.total_group_posts,
    total_any_group_posts: l.total_any_group_posts,
    total_listening_posts: l.total_listening_posts,
    total_proprietary_posts: l.total_proprietary_posts,
    total_competitors_proprietary_posts: l.total_competitors_proprietary_posts,
    size: l.size,
  };
}

